import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import "./subscription-header.component.css";
import bannerImage from "../../../../../img/default-banner-bg.jpg";
import ProfileImage from "../../../../../img/AT&T.png";
import Icon from "../../../../components/icon";
import SubscriptionOverviewInfo from "./subcription-body-component";
import UsageChart from "../usage-chart/usage-chart.component";
import MonthlySpend from "../../dashboard/personal/monthly-spend.component";
import userImage from "../../../../../img/Avatar.png";
import Moment from 'moment';
import MonthlyTrend from "../personal/monthly-trend.component";
import UsageSpendLayout from "../../../common/graph/usagespend-layout.component";
import BreakdownUsageTrend from "../../../common/graph/breakdown-usage.component";
import Avatar from "../../../common/avatar/Avatar";
import { inventoryUsageSpendActions } from "../../../../store/external/inventory/usagespend.reducer";
import { Loading } from "../../../common/loading";
import { inventoryCircuitInvoiceActions } from "../../../../store/external/inventory/invoice/invoice.reducer";
import { adminSettingActions } from "../../../../store/admin-setting.reducer";
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
class SubscriptionHeader extends Component {
    constructor(props) {
        super(props);
        this.imageRef = {
            monthlyTrendRef: React.createRef(),
            breakdownUsageTrendRef: React.createRef(),
        };
        this.state = {  
            chartWidth: window.innerWidth <= 1440 ? 650 : window.innerWidth <=1560 ? 710 : window.innerWidth <=1770 ? 920 : window.innerWidth <=1780 ? 780 : (window.innerWidth <= 1790 ? 750 : 1080),
            startDate:Moment.utc(new Date()).format('MMMM YYYY'),       
            ledger: [
                { name: 'TotalNetAmount', label: 'Net Amount', color: '#ff861c' },
                { name: 'TotalGrossAmount', label: 'Gross Amount', color: '#0000ff' },
                ],
            dateFormat: "MMMM yyyy",
            isInitialLoaded: false,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.getInventoryUsageSpend(this.state.isInitialLoaded, this.props.activeCircuit.CircuitId, this.props.activeCircuit.FinanceAccountId);
        this.props.getInventoryCircuitInvoice(this.props.activeCircuit.CircuitId, this.props.activeCircuit.FinanceAccountId);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
        this.getInventoryUsageSpend(nextProps);
    }

    handleResize = () => {
        this.setState({
            chartWidth: window.innerWidth <= 1440 ? 650 : window.innerWidth <=1560 ? 710 : window.innerWidth <=1770 ? 920 : window.innerWidth <=1780 ? 780 : (window.innerWidth <= 1790 ? 750 : 1080),
        });
    };

    SelectDatePicker(date) {
        this.setState({
            startDate: date,
            isInitialLoaded: true,
        });
        this.props.getInventoryUsageSpend(this.props.activeCircuit.CircuitId, this.props.activeCircuit.FinanceAccountId, date);
    }

    getInventoryUsageSpend(value, circuitId, financeAccountId) {
        if (!value) {
            this.props.getInventoryUsageSpend(circuitId, financeAccountId);
            this.setState({
                isInitialLoaded: true,
            });
        }
    }
    getDisplayUTC(){
        const { adminSetting } = this.props;
        return `(UTC${(adminSetting.activeTimeZoneOffset?.UtcOffset)})`;
    }
    getDisplayDateOrTime(format) {
        const { adminSetting } = this.props;
        const utcOffset = adminSetting.activeTimeZoneOffset?.UtcOffset || 0;
        const formattedDate = convertToFormatTimeZoneDate(new Date(), format, utcOffset);
        const replacementChar = format.toLowerCase() === 'hh:mm a' ? ':' : '-';
        return formattedDate.replace(/[<>:"/\|?*]/g, replacementChar);            
    }
    PrintData(value) {
        this.setState({ printData: value })
    }

    render() {
        const { activeMenu, history, title, planInfo, planName, userName, subscriptionType, userPhoneNumber, phoneNumberType, usageChart, spendChart,
            firstLineColor, secondLineColor, thirdLineColor, forthLineColor, lineYAxis, productDetails, activeCircuit, fetchCircuitData,
            graphHeader, graphFooter, barData, dropdownValues, vendorName, circuitStatus, simCount, simType, equipmentCount, equipmentModel, equipmentType, subscriptionIsPrimary, currencySymbol, setAsPrimary,
            selectedUsageMonth, onUsageMonthSelect, usageMonthOptions, usageSpendLineData, usageSpendBarData, usageSpendLineDataSix, usageSpendCurrMonthTotal, vendorLogo, inventoryUsageSpend, inventoryCircuitInvoice, upgradeEligibilityDate } = this.props;


        const extractedInvoiceDate = inventoryCircuitInvoice.inventoryCircuitInvoiceItems.Data.Items.map(item => {
            const date = new Date(item.InvoiceDate);
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return { InvoiceMonth: month, InvoiceYear: year };
        });

        return (
            <div className="subscription-overview-wrapper">
                <div className="subscription-overview-container">
                    <div className="subscription-header-container">
                        <img className="banner-image" src={bannerImage} alt="banner" />
                        <div className="subscription-header-content">
                            <h1 className="subscription-title">{title}</h1>
                            <div className="subscription-time-container">
                                <h2 className="subscriptiion-date-time">{this.getDisplayDateOrTime('ddd, MMM DD, YYYY')}</h2>
                                <span className="subscriptiion-date-time">|</span>
                                <h2 className="subscriptiion-date-time">{this.getDisplayDateOrTime('hh:mm A')}</h2>
                                <span className="subscriptiion-date-time">|</span>
                                <h2 className="subscriptiion-date-time">{this.getDisplayUTC()}</h2>
                            </div>
                        </div>
                        <Avatar className="subscription-client-logo" src={vendorLogo} text={vendorName} />
                    </div>
                    <SubscriptionOverviewInfo
                        history={history}
                        activeMenu={activeMenu}
                        planInfo={planInfo}
                        planName={planName}
                        productDetails={productDetails}
                        subscriptionType={subscriptionType}
                        userLogo={userImage}
                        userName={userName}
                        userPhoneNumber={userPhoneNumber}
                        phoneNumberType={phoneNumberType}
                        vendorName={vendorName}
                        activeCircuit={activeCircuit}
                        subscriptionIsPrimary={subscriptionIsPrimary}
                        circuitStatus={circuitStatus}
                        simCount={simCount}
                        simType={simType}
                        equipmentCount={equipmentCount}
                        equipmentModel={equipmentModel}
                        equipmentType={equipmentType}
                        currencySymbol={currencySymbol}
                        setAsPrimary={setAsPrimary}
                        fetchCircuitData={fetchCircuitData}
                        vendorLogo={vendorLogo}
                        upgradeEligibilityDate={upgradeEligibilityDate} />
                </div>
                {
                    inventoryUsageSpend.isInventoryUsageSpendLoaded ?
                     <UsageSpendLayout printData={this.PrintData.bind(this)} selectDatePicker={this.SelectDatePicker.bind(this)} imageRef={this.imageRef} circuitId={activeCircuit.CircuitId} circuitCode={activeCircuit.CircuitCode}>
                        <div id="chart-container">
                                <MonthlyTrend
                                invoiceMonth={extractedInvoiceDate}  
                                usageSpendBarData={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthUsageSpend}
                                usageSpendLineDataSix={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.sixMonthsUsageSpend}                           
                                chartWidth={this.state.chartWidth}
                                ledger={this.state.ledger}
                                setRef={ref => {
                                    this.imageRef.monthlyTrendRef = ref;
                                    if (this.monthlyTrendRef && this.breakdownUsageTrendRef) {
                                        this.setState({ loading: false });
                                    }
                                }}
                                selectedMonth={this.state.startDate}
                            />         
                            <BreakdownUsageTrend
                                dateCurrentMonth={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthUsageSpend}
                                usageSpendLineData={this.props.inventoryUsageSpend.inventoryUsageSpendItems.summaryUsageSpendBreakdown.currentMonthBreakdown}
                                chartWidth={1300}
                                printData={this.state.printData}
                                resetData={this.PrintData.bind(this)}
                                setRef={ref => {
                                    this.imageRef.breakdownUsageTrendRef = ref;
                                    if (this.breakdownUsageTrendRef && this.breakdownUsageTrendRef) {
                                        this.setState({ loading: false });
                                    }
                                }}
                            />
                        </div>
                    </UsageSpendLayout>
                    : <Loading />
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { inventoryUsageSpend, inventoryCircuitInvoice, adminSetting } = state;

        return {
            inventoryCircuitInvoice,
            inventoryUsageSpend,
            adminSetting
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryUsageSpendActions, inventoryCircuitInvoiceActions, adminSettingActions),
        dispatch
    )
)(SubscriptionHeader);